export const translationConfig = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.ProfileBadges'
};

export default translationConfig;
